import { Component, Vue } from "vue-property-decorator";
import { gql } from "graphql-tag";
import { MORE_INFORMATION_QUERY } from "@/graphql/more-information-query";
import { InformationlData } from "./information.interface";

@Component({})
export default class MoreInformationComponent extends Vue {
  public informationlData: InformationlData[] = [];
  public currentRoute = "";

  public async created() {
    this.currentRoute = this.$route.path.split("/")[1];
    await this.$apollo
      .query({
        query: gql`query ${MORE_INFORMATION_QUERY}`,
      })
      .then((result) => {
        this.informationlData = result.data.moreInformations.data;
      });
    this.$nextTick(() => {
      const getDescriptionElement =
        document.getElementsByClassName("description")[0];
      const getImageFigureElement =
        getDescriptionElement.getElementsByClassName("image");
      for (let i = 0; i < getImageFigureElement.length; i++) {
        getImageFigureElement[i].classList.add(`image-${i + 1}`);
      }
    });
  }

  /**
   * Column width follows the number of CMS blocks so adding the Ethics
   * Complaint card gives three columns instead of wrapping to a second row.
   */
  public cardColumnClass(blocks: unknown[]): string {
    const count = Array.isArray(blocks) ? blocks.length : 0;
    if (count >= 3) {
      return "col-md-4";
    }
    return "col-md-6";
  }

  /**
   * Strapi appends new blocks to the end of the list, but the Ethics Complaint
   * card belongs between "For More Information" and "Need Help". Rather than
   * relying on an editor dragging it into place, position it centrally here.
   */
  public orderedBlocks(blocks: any[]): any[] {
    if (!Array.isArray(blocks) || blocks.length < 3) {
      return blocks || [];
    }
    const isComplaint = (block: any) => /complaint/i.test(block?.label || "");
    const complaint = blocks.filter(isComplaint);
    if (!complaint.length) {
      return blocks;
    }
    const others = blocks.filter((block) => !isComplaint(block));
    const middle = Math.floor(others.length / 2);
    return [...others.slice(0, middle), ...complaint, ...others.slice(middle)];
  }

  /**
   * The card bodies are CMS-authored HTML, so links inside them (such as
   * "Ethics Complaint Form" pointing at /complaint) are plain anchors and would
   * otherwise reload the whole app. Route internal ones through vue-router and
   * leave external links alone.
   */
  public onDescriptionClick(event: MouseEvent) {
    const anchor = (event.target as HTMLElement)?.closest("a");
    if (!anchor) {
      return;
    }
    const href = anchor.getAttribute("href");
    if (!href || !href.startsWith("/") || anchor.getAttribute("target")) {
      return;
    }
    const resolved = this.$router.resolve(href);
    if (!resolved?.route?.matched?.length) {
      return;
    }
    event.preventDefault();
    if (href !== this.$route.fullPath) {
      this.$router.push(href);
    }
  }
}
